// extracted by mini-css-extract-plugin
export default {"header":"bK","light":"cK","dark":"eK","headertitle":"fK","fname":"gK","headerContent":"hK","right":"iK","descriptionwrapper":"jK","appear":"kK","second":"lK","third":"mK","forth":"nK"};
    if(module.hot) {
      // 1715632479125
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  